export default "__VITE_ASSET__Bz_zxPgl__"